/* eslint-disable */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import {
  Table,
  Tabs,
  Button,
  Space,
  Typography,
  Modal,
  message,
  Input,
  Image,
  Popconfirm,
  Pagination,
  Tag,
} from 'antd';
import '../../components/mobile-order/MobileOrder.css';
import MobileOrderCard from '../../components/mobile-order/MobileOrderCard';
import MobileProductItem from '../../components/mobile-order/MobileProductItem';
import {
  ReloadOutlined,
  EyeOutlined,
  DollarCircleOutlined,
  ShopOutlined,
  UserOutlined,
  CreditCardOutlined,
  ShoppingCartOutlined,
  DollarOutlined,
  FileTextOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';
import { orderStatus } from '../library';
import InfoCard, { InfoRow, InfoGrid } from '../../components/info-card/InfoCard';

dayjs.extend(buddhistEra);
dayjs.locale('th');

const { Title, Text } = Typography;

const formatCurrency = (val) =>
  Number(val || 0).toLocaleString(undefined, { minimumFractionDigits: 2 });

const renderShopInfo = (shopName, province) => (
  <Space direction='vertical' size={0}>
    <Text strong>{shopName}</Text>
    <Text type='secondary' style={{ fontSize: '12px' }}>
      {province}
    </Text>
  </Space>
);

const renderCurrency = (val) => formatCurrency(val);
const renderCurrencyBold = (val) => (
  <Text strong type='success'>
    {formatCurrency(val)}
  </Text>
);

const productItemColumns = [
  { title: 'หน่วย', dataIndex: 'unit', render: (val) => `ชุด ${val} ชิ้น` },
  { title: 'วันหมดอายุ', dataIndex: 'expire', render: (val) => dayjs(val).format('DD MMM BBBB') },
  { title: 'จำนวน', dataIndex: 'select', render: (val) => `x ${val}` },
  {
    title: 'ยอดรวม',
    dataIndex: 'subtotal',
    align: 'right',
    render: (val) => `฿ ${Number(val).toLocaleString()}`,
  },
];

const OrderRefund = (props) => {
  const [loading, setLoading] = useState(false);
  const [orderList, setOrderList] = useState([]);

  const [activeTab, setActiveTab] = useState('pending');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentOrder, setCurrentOrder] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [paymentTransaction, setPaymentTransaction] = useState('');

  useEffect(() => {
    fetchRefundList();
  }, [activeTab]);

  const fetchRefundList = async () => {
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('mode', 'refund');
      if (activeTab === 'history') {
        formData.append('status', 'processed');
      }

      const response = await axios.post(
        `${props.app_hostname}/api/order/admin/common/getorderlistbyfilter`,
        formData,
        { headers: { Authorization: `Bearer ${props.permitdata.token}` } },
      );

      if (response.data.status === 'OK') {
        setOrderList(response.data.order);
      } else {
        message.error(response.data.message || 'เกิดข้อผิดพลาดในการโหลดข้อมูล');
      }
    } catch (err) {
      message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
    } finally {
      setLoading(false);
    }
  };

  const fetchOrderDetail = async (orderId) => {
    setModalLoading(true);
    setPaymentTransaction('');

    try {
      const formData = new FormData();
      formData.append('order_id', orderId);

      const response = await axios.post(
        `${props.app_hostname}/api/order/admin/common/getorderbyid`,
        formData,
        { headers: { Authorization: `Bearer ${props.permitdata.token}` } },
      );

      if (response.data.status === 'OK') {
        setCurrentOrder(response.data.order[0]);
        setIsModalOpen(true);
      } else {
        message.error(response.data.message || 'ไม่พบข้อมูลคำสั่งซื้อ');
      }
    } catch (err) {
      message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
    } finally {
      setModalLoading(false);
    }
  };

  const handleRefundPay = async () => {
    if (!paymentTransaction) {
      message.warning('กรุณากรอกเลขธุรกรรมคืนเงิน');
      return;
    }

    setModalLoading(true);

    try {
      const formData = new FormData();
      formData.append('order_id', currentOrder.order_id);
      formData.append('payment_transaction', paymentTransaction);
      formData.append('buyer_shopid', currentOrder.buyer_shopid);

      const response = await axios.post(
        `${props.app_hostname}/api/order/admin/refund/payrefund`,
        formData,
        { headers: { Authorization: `Bearer ${props.permitdata.token}` } },
      );

      if (response.data.status === 'OK') {
        message.success('บันทึกการคืนเงินสำเร็จ');
        setIsModalOpen(false);

        if (response.data.reload) {
          setOrderList((prev) => prev.filter((item) => item.order_id !== response.data.order_id));
        } else {
          fetchRefundList();
        }
      } else {
        message.error(response.data.message || 'เกิดข้อผิดพลาด');
      }
    } catch (err) {
      message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
    } finally {
      setModalLoading(false);
    }
  };

  const columns = [
    {
      title: '#',
      key: 'index',
      width: 60,
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: 'รหัสคำสั่งซื้อ',
      dataIndex: 'order_id',
      key: 'order_id',
      sorter: (a, b) => a.order_id?.localeCompare(b.order_id),
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: 'วันที่สั่งซื้อ',
      dataIndex: 'createtime',
      key: 'createtime',
      sorter: (a, b) => dayjs(a.createtime).unix() - dayjs(b.createtime).unix(),
      defaultSortOrder: 'descend',
      render: (text) => dayjs(text).format('DD/MM/YYYY HH:mm'),
    },
    {
      title: 'ผู้ซื้อ',
      key: 'buyer',
      sorter: (a, b) => a.buyer_shopname?.localeCompare(b.buyer_shopname),
      render: (_, record) => renderShopInfo(record.buyer_shopname, record.buyer_shopprovince),
    },
    {
      title: 'ผู้ขาย',
      key: 'seller',
      sorter: (a, b) => a.seller_shopname?.localeCompare(b.seller_shopname),
      render: (_, record) => renderShopInfo(record.seller_shopname, record.seller_shopprovince),
    },
    {
      title: 'ยอดรวม',
      dataIndex: 'shop_subtotal',
      key: 'shop_subtotal',
      align: 'right',
      sorter: (a, b) => Number(a.shop_subtotal) - Number(b.shop_subtotal),
      render: renderCurrency,
    },
    {
      title: 'ค่าจัดส่ง',
      dataIndex: 'shop_shipping_markup',
      key: 'shop_shipping_markup',
      align: 'right',
      sorter: (a, b) => Number(a.shop_shipping_markup) - Number(b.shop_shipping_markup),
      render: renderCurrency,
    },
    {
      title: 'ยอดที่ต้องคืนผู้ซื้อ',
      key: 'refund_total',
      align: 'right',
      sorter: (a, b) => {
        const aTotal =
          a.order_status === 'PC_RTN_RCV'
            ? Number(a.return_shop_total || 0)
            : Number(a.shop_total || 0);
        const bTotal =
          b.order_status === 'PC_RTN_RCV'
            ? Number(b.return_shop_total || 0)
            : Number(b.shop_total || 0);
        return aTotal - bTotal;
      },
      render: (_, record) => {
        const total =
          record.order_status === 'PC_RTN_RCV' ? record.return_shop_total : record.shop_total;
        return (
          <Text strong type='danger'>
            {formatCurrency(total)}
          </Text>
        );
      },
    },
    {
      title: 'จัดการ',
      key: 'action',
      width: 120,
      align: 'center',
      fixed: 'right', // Pinned to right side during horizontal scroll for desktop usability
      render: (_, record) => (
        <Button
          type='primary'
          icon={<EyeOutlined />}
          size='small'
          onClick={() => fetchOrderDetail(record.order_id)}
        >
          รายละเอียด
        </Button>
      ),
    },
  ];

  const paginationConfig = {
    pageSize,
    current: currentPage,
    showTotal: (total) => `รวม ${total} รายการ`,
    onChange: (page, size) => {
      setCurrentPage(page);
      setPageSize(size);
    },
  };

  // Mobile Product Item renders are now handled by MobileProductItem shared component

  const renderRefundSummary = () => {
    const isReturnOrder = currentOrder.order_status === 'PC_RTN_RCV';

    if (isReturnOrder) {
      return (
        <InfoCard title='สรุปยอดชำระ' icon={<DollarOutlined />} variant='danger'>
          <InfoRow label='ยอดรวมสินค้า' value={`${formatCurrency(currentOrder.shop_subtotal)} ฿`} />
          <InfoRow
            label='ค่าจัดส่ง'
            value={`${formatCurrency(currentOrder.shop_shipping_markup)} ฿`}
          />
          <InfoRow
            label='ยอดรวมทั้งหมด'
            value={`${formatCurrency(currentOrder.shop_total)} ฿`}
            valueColor='green'
          />
          <InfoRow
            label='ยอดที่ต้องคืนผู้ซื้อ'
            value={`${formatCurrency(currentOrder.return_shop_total)} ฿`}
            bold
          />
        </InfoCard>
      );
    }

    return (
      <InfoCard title='สรุปยอดชำระ' icon={<DollarOutlined />} variant='danger'>
        <InfoRow label='ยอดรวมสินค้า' value={`${formatCurrency(currentOrder.shop_subtotal)} ฿`} />
        <InfoRow
          label='ค่าจัดส่ง'
          value={`${formatCurrency(currentOrder.shop_shipping_markup)} ฿`}
        />
        <InfoRow
          label='ยอดที่ต้องคืนผู้ซื้อ'
          value={`${formatCurrency(currentOrder.shop_total)} ฿`}
          bold
        />
      </InfoCard>
    );
  };

  const renderMobileCards = () => {
    return (
      <div className='order-mobile-view'>
        <div className='order-card-container'>
          {orderList.slice((currentPage - 1) * pageSize, currentPage * pageSize).map((record) => (
            <MobileOrderCard
              key={record.order_id}
              record={record}
              onViewDetails={fetchOrderDetail}
              totalClass='danger'
            />
          ))}
        </div>
        <div style={{ marginTop: '24px', display: 'flex', justifyContent: 'center' }}>
          <Pagination {...paginationConfig} showSizeChanger={false} size='small' />
        </div>
      </div>
    );
  };

  const renderTable = () =>
    props.isMobile ? (
      renderMobileCards()
    ) : (
      <div className='order-desktop-view'>
        <Table
          columns={columns}
          dataSource={orderList}
          rowKey='order_id'
          loading={loading}
          pagination={paginationConfig}
          scroll={{ x: true }}
          size='small'
        />
      </div>
    );

  const tabItems = [
    { key: 'pending', label: 'รายการรออนุมัติ', children: renderTable() },
    { key: 'history', label: 'ประวัติการคืนเงิน', children: renderTable() },
  ];

  return (
    <div className='page-wrapper'>
      <div className='page-card'>
        <Space direction='vertical' size='large' style={{ width: '100%' }}>
          <div className='page-header-actions'>
            <div>
              <Title level={3} style={{ margin: 0 }}>
                <DollarCircleOutlined style={{ color: '#fa8c16', marginRight: '8px' }} />
                คืนเงินผู้ซื้อ
              </Title>
              <Text type='secondary'>จัดการการคืนเงินให้ผู้ซื้อ</Text>
            </div>
            <Button icon={<ReloadOutlined />} onClick={fetchRefundList} loading={loading}>
              รีเฟรช
            </Button>
          </div>

          <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabItems} type='card' />
        </Space>
      </div>

      <Modal
        title={
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              width: '95%',
            }}
          >
            <Text strong style={{ fontSize: '18px' }}>
              {currentOrder?.order_id}
            </Text>
            <div style={{ textAlign: 'right' }}>
              <Text type='secondary' style={{ fontSize: '12px', display: 'block' }}>
                ผู้ซื้อ: {currentOrder?.buyer_shopname}
              </Text>
              <Text type='danger' style={{ fontSize: '10px' }}>
                สถานะคำสั่งซื้อ: {currentOrder?.order_status_name || 'ผู้ขายยกเลิกคำสั่งซื้อ'}
              </Text>
            </div>
          </div>
        }
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={props.isMobile ? '95%' : 800}
        centered
        className='custom-modal'
      >
        {currentOrder && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <InfoCard title='ข้อมูลใบกำกับ' icon={<FileTextOutlined />} variant='danger' compact>
              <InfoGrid columns={2}>
                <InfoRow label='รหัสคำสั่งซื้อ' value={currentOrder.order_id} />
                <InfoRow
                  label='วันที่สั่งซื้อ'
                  value={dayjs(currentOrder.createtime).format('DD MMM BBBB HH:mm')}
                />
                <InfoRow label='ผู้ขาย' value={currentOrder.seller_shopname} />
                <InfoRow label='วิธีการชำระ' value={currentOrder.payment_method || '-'} />
              </InfoGrid>
            </InfoCard>

            <InfoCard
              title={`สินค้า: ${currentOrder.order_id}`}
              icon={<ShoppingCartOutlined />}
              variant='danger'
            >
              {currentOrder.orderitem?.map((item, idx) => (
                <MobileProductItem
                  key={item.productitem_id || idx}
                  item={item}
                  idx={idx}
                  appHostname={props.app_hostname}
                />
              ))}
            </InfoCard>

            {renderRefundSummary()}

            <InfoCard
              title='บัญชีธนาคารผู้ซื้อ'
              icon={<CreditCardOutlined />}
              variant='danger'
              compact
            >
              <InfoRow label='ธนาคาร' value={currentOrder.buyer_bank_name} />
              <InfoRow label='ชื่อบัญชี' value={currentOrder.buyer_bank_acc_name} />
              <InfoRow label='เลขที่บัญชี' value={currentOrder.buyer_bank_acc_id} />
              <InfoRow
                label='เบอร์โทรศัพท์'
                value={currentOrder.buyer_telno || currentOrder.shipping_telno || '-'}
              />
              <InfoRow label='อีเมล' value={currentOrder.buyer_email || '-'} />
            </InfoCard>

            {currentOrder.order_status === 'PC_RTN_RCV' && (
              <InfoCard variant='danger' compact>
                <Text type='danger'>เหตุผลในการขอคืนสินค้า: </Text>
                <Text>{currentOrder.return_reason}</Text>
              </InfoCard>
            )}

            {currentOrder.refund_paid ? (
              <InfoCard title='สถานะการดำเนินการ' icon={<CheckCircleOutlined />} variant='neutral'>
                <InfoRow
                  label='สถานะ'
                  value={
                    <Tag color='success' style={{ margin: 0 }}>
                      คืนเงินเรียบร้อยแล้ว
                    </Tag>
                  }
                />
                <InfoRow
                  label='เลขธุรกรรมคืนเงิน'
                  value={currentOrder.refund_paid_ref || '-'}
                  bold
                />
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '12px' }}>
                  <Button onClick={() => setIsModalOpen(false)}>ปิดหน้าต่าง</Button>
                </div>
              </InfoCard>
            ) : (
              <InfoCard title='ดำเนินการ' variant='danger'>
                <div style={{ marginBottom: '12px' }}>
                  <Text
                    strong
                    type='warning'
                    style={{ fontSize: '12px', display: 'block', marginBottom: '6px' }}
                  >
                    กรอกเลขธุรกรรมคืนเงิน
                  </Text>
                  <Input
                    placeholder='กรอกเลขธุรกรรมคืนเงิน'
                    value={paymentTransaction}
                    onChange={(e) => setPaymentTransaction(e.target.value)}
                  />
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                  <Button onClick={() => setIsModalOpen(false)}>ปิดหน้าต่าง</Button>
                  <Popconfirm
                    title='ยืนยันการคืนเงิน'
                    description='คุณแน่ใจหรือไม่ที่จะบันทึกการคืนเงินนี้?'
                    onConfirm={handleRefundPay}
                    okText='ยืนยัน'
                    cancelText='ยกเลิก'
                  >
                    <Button type='primary' danger loading={modalLoading}>
                      คืนเงินแล้ว
                    </Button>
                  </Popconfirm>
                </div>
              </InfoCard>
            )}
          </div>
        )}
      </Modal>
    </div>
  );
};

export default OrderRefund;
